module.exports = __webpack_public_path__ + "img/maximize.04e1c4ad.svg";